import { BlokPalette } from '../types/blok'

type PflegeColorNames = 'white' | 'mint-lightest' | 'neutral-5' | ''

export function getPflegeColorName(palette: BlokPalette): PflegeColorNames
export function getPflegeColorName(hex: string): PflegeColorNames

export function getPflegeColorName(hex: string | BlokPalette) {
  if (typeof hex === 'object') {
    hex = hex.value
  }
  switch (hex) {
    case '#ffffff':
    case '#fff':
    case '#ffff':
    case '#ffffffff':
      return 'white'
    case '#f1f7f7':
    case '#f1f7f7ff':
      return 'mint-lightest'
    case '#f2f2f2':
    case '#0000000d':
      return 'neutral-5'
    default:
      return ''
  }
}
